module.exports = {table:
{
  "*[AND_TOKEN,inlineShapeNot]" : {
     "AND_TOKEN": ["[AND_TOKEN,inlineShapeNot]","*[AND_TOKEN,inlineShapeNot]"], 
     "OR": [], 
     "%": [], 
     "DOUBLE_SLASH": [], 
     "*": [], 
     "+": [], 
     "?": [], 
     "REPEAT_RANGE": [], 
     "|": [], 
     ";": [], 
     ")": [], 
     "}": []}, 
  "*[AND_TOKEN,shapeNot]" : {
     "AND_TOKEN": ["[AND_TOKEN,shapeNot]","*[AND_TOKEN,shapeNot]"], 
     "OR": [], 
     ")": [], 
     "BASE": [], 
     "PREFIX": [], 
     "IMPORT": [], 
     "START": [], 
     "KW_ABSTRACT": [], 
     "IRI_REF": [], 
     "BLANK_NODE_LABEL": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "$": []}, 
  "*[OR,inlineShapeAnd]" : {
     "OR": ["[OR,inlineShapeAnd]","*[OR,inlineShapeAnd]"], 
     "%": [], 
     "DOUBLE_SLASH": [], 
     "*": [], 
     "+": [], 
     "?": [], 
     "REPEAT_RANGE": [], 
     "|": [], 
     ";": [], 
     ")": [], 
     "}": []}, 
  "*[OR,shapeAnd]" : {
     "OR": ["[OR,shapeAnd]","*[OR,shapeAnd]"], 
     ")": [], 
     "BASE": [], 
     "PREFIX": [], 
     "IMPORT": [], 
     "START": [], 
     "KW_ABSTRACT": [], 
     "IRI_REF": [], 
     "BLANK_NODE_LABEL": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "$": []}, 
  "*annotation" : {
     "DOUBLE_SLASH": ["annotation","*annotation"], 
     "%": [], 
     "OR": [], 
     "AND_TOKEN": [], 
     "|": [], 
     ";": [], 
     ")": [], 
     "}": [], 
     "BASE": [], 
     "PREFIX": [], 
     "IMPORT": [], 
     "START": [], 
     "KW_ABSTRACT": [], 
     "IRI_REF": [], 
     "BLANK_NODE_LABEL": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "$": []}, 
  "*codeDecl" : {
     "%": ["codeDecl","*codeDecl"], 
     "OR": [], 
     "AND_TOKEN": [], 
     "|": [], 
     ";": [], 
     "BASE": [], 
     "PREFIX": [], 
     "IMPORT": [], 
     "START": [], 
     "KW_ABSTRACT": [], 
     "IRI_REF": [], 
     "BLANK_NODE_LABEL": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     ")": [], 
     "}": [], 
     "$": []}, 
  "*directive" : {
     "BASE": ["directive","*directive"], 
     "PREFIX": ["directive","*directive"], 
     "IMPORT": ["directive","*directive"], 
     "$": [], 
     "START": [], 
     "KW_ABSTRACT": [], 
     "%": [], 
     "IRI_REF": [], 
     "BLANK_NODE_LABEL": [], 
     "PNAME_LN": [], 
     "PNAME_NS": []}, 
  "*exclusion" : {
     "-": ["exclusion","*exclusion"], 
     ".": [], 
     "IRI_REF": [], 
     "INTEGER": [], 
     "DECIMAL": [], 
     "DOUBLE": [], 
     "TRUE": [], 
     "FALSE": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "STRING_LITERAL1": [], 
     "STRING_LITERAL_LONG1": [], 
     "STRING_LITERAL2": [], 
     "STRING_LITERAL_LONG2": [], 
     "]": []}, 
  "*predicate" : {
     "A_TOKEN": ["predicate","*predicate"], 
     "IRI_REF": ["predicate","*predicate"], 
     "PNAME_LN": ["predicate","*predicate"], 
     "PNAME_NS": ["predicate","*predicate"], 
     "CLOSED": [], 
     "EXTENDS": [], 
     "&": [], 
     "RESTRICTS": [], 
     "-": [], 
     "EXTRA": [], 
     "{": []}, 
  "*qualifier" : {
     "CLOSED": ["qualifier","*qualifier"], 
     "EXTENDS": ["qualifier","*qualifier"], 
     "&": ["qualifier","*qualifier"], 
     "RESTRICTS": ["qualifier","*qualifier"], 
     "-": ["qualifier","*qualifier"], 
     "EXTRA": ["qualifier","*qualifier"], 
     "{": []}, 
  "*shapeRef" : {
     "ATPNAME_NS": ["shapeRef","*shapeRef"], 
     "ATPNAME_LN": ["shapeRef","*shapeRef"], 
     "@": ["shapeRef","*shapeRef"], 
     "CLOSED": [], 
     "EXTENDS": [], 
     "&": [], 
     "RESTRICTS": [], 
     "-": [], 
     "EXTRA": [], 
     "{": []}, 
  "*statement" : {
     "BASE": ["statement","*statement"], 
     "PREFIX": ["statement","*statement"], 
     "IMPORT": ["statement","*statement"], 
     "START": ["statement","*statement"], 
     "KW_ABSTRACT": ["statement","*statement"], 
     "IRI_REF": ["statement","*statement"], 
     "BLANK_NODE_LABEL": ["statement","*statement"], 
     "PNAME_LN": ["statement","*statement"], 
     "PNAME_NS": ["statement","*statement"], 
     "$": []}, 
  "*stringFacet" : {
     "REGEXP": ["stringFacet","*stringFacet"], 
     "LENGTH": ["stringFacet","*stringFacet"], 
     "MINLENGTH": ["stringFacet","*stringFacet"], 
     "MAXLENGTH": ["stringFacet","*stringFacet"], 
     "OR": [], 
     "AND_TOKEN": [], 
     "ATPNAME_NS": [], 
     "ATPNAME_LN": [], 
     "@": [], 
     "{": [], 
     "CLOSED": [], 
     "EXTENDS": [], 
     "&": [], 
     "RESTRICTS": [], 
     "-": [], 
     "EXTRA": [], 
     ")": [], 
     "%": [], 
     "DOUBLE_SLASH": [], 
     "*": [], 
     "+": [], 
     "?": [], 
     "REPEAT_RANGE": [], 
     "BASE": [], 
     "PREFIX": [], 
     "IMPORT": [], 
     "START": [], 
     "KW_ABSTRACT": [], 
     "IRI_REF": [], 
     "BLANK_NODE_LABEL": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "|": [], 
     ";": [], 
     "}": [], 
     "$": []}, 
  "*valueSetValue" : {
     ".": ["valueSetValue","*valueSetValue"], 
     "IRI_REF": ["valueSetValue","*valueSetValue"], 
     "INTEGER": ["valueSetValue","*valueSetValue"], 
     "DECIMAL": ["valueSetValue","*valueSetValue"], 
     "DOUBLE": ["valueSetValue","*valueSetValue"], 
     "TRUE": ["valueSetValue","*valueSetValue"], 
     "FALSE": ["valueSetValue","*valueSetValue"], 
     "PNAME_LN": ["valueSetValue","*valueSetValue"], 
     "PNAME_NS": ["valueSetValue","*valueSetValue"], 
     "STRING_LITERAL1": ["valueSetValue","*valueSetValue"], 
     "STRING_LITERAL_LONG1": ["valueSetValue","*valueSetValue"], 
     "STRING_LITERAL2": ["valueSetValue","*valueSetValue"], 
     "STRING_LITERAL_LONG2": ["valueSetValue","*valueSetValue"], 
     "]": []}, 
  "*xsFacet" : {
     "REGEXP": ["xsFacet","*xsFacet"], 
     "LENGTH": ["xsFacet","*xsFacet"], 
     "MINLENGTH": ["xsFacet","*xsFacet"], 
     "MAXLENGTH": ["xsFacet","*xsFacet"], 
     "MININCLUSIVE": ["xsFacet","*xsFacet"], 
     "MINEXCLUSIVE": ["xsFacet","*xsFacet"], 
     "MAXINCLUSIVE": ["xsFacet","*xsFacet"], 
     "MAXEXCLUSIVE": ["xsFacet","*xsFacet"], 
     "TOTALDIGITS": ["xsFacet","*xsFacet"], 
     "FRACTIONDIGITS": ["xsFacet","*xsFacet"], 
     "OR": [], 
     "AND_TOKEN": [], 
     "ATPNAME_NS": [], 
     "ATPNAME_LN": [], 
     "@": [], 
     "{": [], 
     "CLOSED": [], 
     "EXTENDS": [], 
     "&": [], 
     "RESTRICTS": [], 
     "-": [], 
     "EXTRA": [], 
     ")": [], 
     "%": [], 
     "DOUBLE_SLASH": [], 
     "*": [], 
     "+": [], 
     "?": [], 
     "REPEAT_RANGE": [], 
     "BASE": [], 
     "PREFIX": [], 
     "IMPORT": [], 
     "START": [], 
     "KW_ABSTRACT": [], 
     "IRI_REF": [], 
     "BLANK_NODE_LABEL": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "|": [], 
     ";": [], 
     "}": [], 
     "$": []}, 
  "+codeDecl" : {
     "%": ["codeDecl","*codeDecl"]}, 
  "+exclusion" : {
     "-": ["exclusion","*exclusion"]}, 
  "+predicate" : {
     "A_TOKEN": ["predicate","*predicate"], 
     "IRI_REF": ["predicate","*predicate"], 
     "PNAME_LN": ["predicate","*predicate"], 
     "PNAME_NS": ["predicate","*predicate"]}, 
  "+shapeRef" : {
     "ATPNAME_NS": ["shapeRef","*shapeRef"], 
     "ATPNAME_LN": ["shapeRef","*shapeRef"], 
     "@": ["shapeRef","*shapeRef"]}, 
  "+xsFacet" : {
     "REGEXP": ["xsFacet","*xsFacet"], 
     "LENGTH": ["xsFacet","*xsFacet"], 
     "MINLENGTH": ["xsFacet","*xsFacet"], 
     "MAXLENGTH": ["xsFacet","*xsFacet"], 
     "MININCLUSIVE": ["xsFacet","*xsFacet"], 
     "MINEXCLUSIVE": ["xsFacet","*xsFacet"], 
     "MAXINCLUSIVE": ["xsFacet","*xsFacet"], 
     "MAXEXCLUSIVE": ["xsFacet","*xsFacet"], 
     "TOTALDIGITS": ["xsFacet","*xsFacet"], 
     "FRACTIONDIGITS": ["xsFacet","*xsFacet"]}, 
  "?KW_ABSTRACT" : {
     "KW_ABSTRACT": ["KW_ABSTRACT"], 
     "IRI_REF": [], 
     "BLANK_NODE_LABEL": [], 
     "PNAME_LN": [], 
     "PNAME_NS": []}, 
  "?NOT" : {
     "NOT": ["NOT"], 
     "(": [], 
     ".": [], 
     "LITERAL": [], 
     "IRI": [], 
     "BNODE": [], 
     "NONLITERAL": [], 
     "[": [], 
     "ATPNAME_NS": [], 
     "ATPNAME_LN": [], 
     "@": [], 
     "IRI_REF": [], 
     "REGEXP": [], 
     "{": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "LENGTH": [], 
     "MINLENGTH": [], 
     "MAXLENGTH": [], 
     "MININCLUSIVE": [], 
     "MINEXCLUSIVE": [], 
     "MAXINCLUSIVE": [], 
     "MAXEXCLUSIVE": [], 
     "TOTALDIGITS": [], 
     "FRACTIONDIGITS": [], 
     "CLOSED": [], 
     "EXTENDS": [], 
     "&": [], 
     "RESTRICTS": [], 
     "-": [], 
     "EXTRA": []}, 
  "?[$,tripleExprLabel]" : {
     "$": ["[$,tripleExprLabel]"], 
     "(": [], 
     "A_TOKEN": [], 
     "^": [], 
     "IRI_REF": [], 
     "PNAME_LN": [], 
     "PNAME_NS": []}, 
  "?[or([notStartAction,startActions]),*statement]" : {
     "START": ["[or([notStartAction,startActions]),*statement]"], 
     "KW_ABSTRACT": ["[or([notStartAction,startActions]),*statement]"], 
     "%": ["[or([notStartAction,startActions]),*statement]"], 
     "IRI_REF": ["[or([notStartAction,startActions]),*statement]"], 
     "BLANK_NODE_LABEL": ["[or([notStartAction,startActions]),*statement]"], 
     "PNAME_LN": ["[or([notStartAction,startActions]),*statement]"], 
     "PNAME_NS": ["[or([notStartAction,startActions]),*statement]"], 
     "$": []}, 
  "?[~,*exclusion]" : {
     "~": ["[~,*exclusion]"], 
     ".": [], 
     "IRI_REF": [], 
     "INTEGER": [], 
     "DECIMAL": [], 
     "DOUBLE": [], 
     "TRUE": [], 
     "FALSE": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "STRING_LITERAL1": [], 
     "STRING_LITERAL_LONG1": [], 
     "STRING_LITERAL2": [], 
     "STRING_LITERAL_LONG2": [], 
     "]": []}, 
  "?cardinality" : {
     "*": ["cardinality"], 
     "+": ["cardinality"], 
     "?": ["cardinality"], 
     "REPEAT_RANGE": ["cardinality"], 
     "%": [], 
     "DOUBLE_SLASH": [], 
     "|": [], 
     ";": [], 
     ")": [], 
     "}": []}, 
  "?inlineShapeOrRef" : {
     "ATPNAME_NS": ["inlineShapeOrRef"], 
     "ATPNAME_LN": ["inlineShapeOrRef"], 
     "@": ["inlineShapeOrRef"], 
     "{": ["inlineShapeOrRef"], 
     "CLOSED": ["inlineShapeOrRef"], 
     "EXTENDS": ["inlineShapeOrRef"], 
     "&": ["inlineShapeOrRef"], 
     "RESTRICTS": ["inlineShapeOrRef"], 
     "-": ["inlineShapeOrRef"], 
     "EXTRA": ["inlineShapeOrRef"], 
     "OR": [], 
     "AND_TOKEN": [], 
     "%": [], 
     "DOUBLE_SLASH": [], 
     "*": [], 
     "+": [], 
     "?": [], 
     "REPEAT_RANGE": [], 
     "|": [], 
     ";": [], 
     ")": [], 
     "}": []}, 
  "?nodeConstraint" : {
     "LITERAL": ["nodeConstraint"], 
     "IRI": ["nodeConstraint"], 
     "BNODE": ["nodeConstraint"], 
     "NONLITERAL": ["nodeConstraint"], 
     "[": ["nodeConstraint"], 
     "IRI_REF": ["nodeConstraint"], 
     "REGEXP": ["nodeConstraint"], 
     "PNAME_LN": ["nodeConstraint"], 
     "PNAME_NS": ["nodeConstraint"], 
     "LENGTH": ["nodeConstraint"], 
     "MINLENGTH": ["nodeConstraint"], 
     "MAXLENGTH": ["nodeConstraint"], 
     "MININCLUSIVE": ["nodeConstraint"], 
     "MINEXCLUSIVE": ["nodeConstraint"], 
     "MAXINCLUSIVE": ["nodeConstraint"], 
     "MAXEXCLUSIVE": ["nodeConstraint"], 
     "TOTALDIGITS": ["nodeConstraint"], 
     "FRACTIONDIGITS": ["nodeConstraint"], 
     "OR": [], 
     "AND_TOKEN": [], 
     "%": [], 
     "DOUBLE_SLASH": [], 
     "*": [], 
     "+": [], 
     "?": [], 
     "REPEAT_RANGE": [], 
     "|": [], 
     ";": [], 
     ")": [], 
     "}": []}, 
  "?senseFlags" : {
     "^": ["senseFlags"], 
     "A_TOKEN": [], 
     "IRI_REF": [], 
     "PNAME_LN": [], 
     "PNAME_NS": []}, 
  "?shapeOrRef" : {
     "ATPNAME_NS": ["shapeOrRef"], 
     "ATPNAME_LN": ["shapeOrRef"], 
     "@": ["shapeOrRef"], 
     "{": ["shapeOrRef"], 
     "CLOSED": ["shapeOrRef"], 
     "EXTENDS": ["shapeOrRef"], 
     "&": ["shapeOrRef"], 
     "RESTRICTS": ["shapeOrRef"], 
     "-": ["shapeOrRef"], 
     "EXTRA": ["shapeOrRef"], 
     "OR": [], 
     "AND_TOKEN": [], 
     ")": [], 
     "BASE": [], 
     "PREFIX": [], 
     "IMPORT": [], 
     "START": [], 
     "KW_ABSTRACT": [], 
     "IRI_REF": [], 
     "BLANK_NODE_LABEL": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "$": []}, 
  "?tripleExpression" : {
     "$": ["tripleExpression"], 
     "(": ["tripleExpression"], 
     "&": ["tripleExpression"], 
     "A_TOKEN": ["tripleExpression"], 
     "^": ["tripleExpression"], 
     "IRI_REF": ["tripleExpression"], 
     "PNAME_LN": ["tripleExpression"], 
     "PNAME_NS": ["tripleExpression"], 
     "}": []}, 
  "?~" : {
     "~": ["~"], 
     "-": [], 
     ".": [], 
     "IRI_REF": [], 
     "INTEGER": [], 
     "DECIMAL": [], 
     "DOUBLE": [], 
     "TRUE": [], 
     "FALSE": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "STRING_LITERAL1": [], 
     "STRING_LITERAL_LONG1": [], 
     "STRING_LITERAL2": [], 
     "STRING_LITERAL_LONG2": [], 
     "]": []}, 
  "[$,tripleExprLabel]" : {
     "$": ["$","tripleExprLabel"]}, 
  "[AND_TOKEN,inlineShapeNot]" : {
     "AND_TOKEN": ["AND_TOKEN","inlineShapeNot"]}, 
  "[AND_TOKEN,shapeNot]" : {
     "AND_TOKEN": ["AND_TOKEN","shapeNot"]}, 
  "[OR,inlineShapeAnd]" : {
     "OR": ["OR","inlineShapeAnd"]}, 
  "[OR,shapeAnd]" : {
     "OR": ["OR","shapeAnd"]}, 
  "[or([notStartAction,startActions]),*statement]" : {
     "START": ["or([notStartAction,startActions])","*statement"], 
     "KW_ABSTRACT": ["or([notStartAction,startActions])","*statement"], 
     "%": ["or([notStartAction,startActions])","*statement"], 
     "IRI_REF": ["or([notStartAction,startActions])","*statement"], 
     "BLANK_NODE_LABEL": ["or([notStartAction,startActions])","*statement"], 
     "PNAME_LN": ["or([notStartAction,startActions])","*statement"], 
     "PNAME_NS": ["or([notStartAction,startActions])","*statement"]}, 
  "[~,*exclusion]" : {
     "~": ["~","*exclusion"]}, 
  "annotation" : {
     "DOUBLE_SLASH": ["DOUBLE_SLASH","predicate","or([iri,literal])"]}, 
  "baseDecl" : {
     "BASE": ["BASE","IRI_REF"]}, 
  "blankNode" : {
     "BLANK_NODE_LABEL": ["BLANK_NODE_LABEL"]}, 
  "booleanLiteral" : {
     "TRUE": ["or([TRUE,FALSE])"], 
     "FALSE": ["or([TRUE,FALSE])"]}, 
  "bracketedTripleExpr" : {
     "(": ["(","tripleExpression",")","?cardinality","*annotation","semanticActions"]}, 
  "cardinality" : {
     "*": ["*"], 
     "+": ["+"], 
     "?": ["?"], 
     "REPEAT_RANGE": ["REPEAT_RANGE"]}, 
  "codeDecl" : {
     "%": ["%","iri","or([CODE,%])"]}, 
  "datatype" : {
     "IRI_REF": ["iri"], 
     "PNAME_LN": ["iri"], 
     "PNAME_NS": ["iri"]}, 
  "directive" : {
     "BASE": ["or([baseDecl,prefixDecl,importDecl])"], 
     "PREFIX": ["or([baseDecl,prefixDecl,importDecl])"], 
     "IMPORT": ["or([baseDecl,prefixDecl,importDecl])"]}, 
  "elementGroup" : {
     "$": ["unaryTripleExpr","singleElementGroup"], 
     "(": ["unaryTripleExpr","singleElementGroup"], 
     "&": ["unaryTripleExpr","singleElementGroup"], 
     "A_TOKEN": ["unaryTripleExpr","singleElementGroup"], 
     "^": ["unaryTripleExpr","singleElementGroup"], 
     "IRI_REF": ["unaryTripleExpr","singleElementGroup"], 
     "PNAME_LN": ["unaryTripleExpr","singleElementGroup"], 
     "PNAME_NS": ["unaryTripleExpr","singleElementGroup"], 
     "|": [], 
     ")": [], 
     "}": []}, 
  "exclusion" : {
     "-": ["-","iri","?~"]}, 
  "extension" : {
     "EXTENDS": ["EXTENDS","+shapeRef"], 
     "&": ["&","+shapeRef"]}, 
  "extraPropertySet" : {
     "EXTRA": ["EXTRA","+predicate"]}, 
  "fmulti" : {
     "|": ["|","unaryTripleExpr","singleElementGroup","fmulti"], 
     ")": [], 
     "}": []}, 
  "fsingle" : {
     "|": ["|","unaryTripleExpr","singleElementGroup","fmulti"], 
     ")": [], 
     "}": []}, 
  "funaryTripleExpr" : {
     "|": ["singleElementGroup","fsingle"], 
     ";": ["singleElementGroup","fsingle"], 
     ")": ["singleElementGroup","fsingle"], 
     "}": ["singleElementGroup","fsingle"]}, 
  "importDecl" : {
     "IMPORT": ["IMPORT","IRI_REF"]}, 
  "include" : {
     "&": ["&","tripleExprLabel"]}, 
  "inlineShapeAnd" : {
     "NOT": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "(": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     ".": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "LITERAL": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "ATPNAME_NS": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "ATPNAME_LN": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "@": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "IRI": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "BNODE": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "NONLITERAL": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "[": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "{": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "IRI_REF": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "REGEXP": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "CLOSED": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "PNAME_LN": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "PNAME_NS": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "LENGTH": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "MINLENGTH": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "MAXLENGTH": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "MININCLUSIVE": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "MINEXCLUSIVE": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "MAXINCLUSIVE": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "MAXEXCLUSIVE": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "TOTALDIGITS": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "FRACTIONDIGITS": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "EXTENDS": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "&": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "RESTRICTS": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "-": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"], 
     "EXTRA": ["inlineShapeNot","*[AND_TOKEN,inlineShapeNot]"]}, 
  "inlineShapeAtom" : {
     "LITERAL": ["nodeConstraint","?inlineShapeOrRef"], 
     "IRI": ["nodeConstraint","?inlineShapeOrRef"], 
     "BNODE": ["nodeConstraint","?inlineShapeOrRef"], 
     "NONLITERAL": ["nodeConstraint","?inlineShapeOrRef"], 
     "[": ["nodeConstraint","?inlineShapeOrRef"], 
     "IRI_REF": ["nodeConstraint","?inlineShapeOrRef"], 
     "REGEXP": ["nodeConstraint","?inlineShapeOrRef"], 
     "PNAME_LN": ["nodeConstraint","?inlineShapeOrRef"], 
     "PNAME_NS": ["nodeConstraint","?inlineShapeOrRef"], 
     "LENGTH": ["nodeConstraint","?inlineShapeOrRef"], 
     "MINLENGTH": ["nodeConstraint","?inlineShapeOrRef"], 
     "MAXLENGTH": ["nodeConstraint","?inlineShapeOrRef"], 
     "MININCLUSIVE": ["nodeConstraint","?inlineShapeOrRef"], 
     "MINEXCLUSIVE": ["nodeConstraint","?inlineShapeOrRef"], 
     "MAXINCLUSIVE": ["nodeConstraint","?inlineShapeOrRef"], 
     "MAXEXCLUSIVE": ["nodeConstraint","?inlineShapeOrRef"], 
     "TOTALDIGITS": ["nodeConstraint","?inlineShapeOrRef"], 
     "FRACTIONDIGITS": ["nodeConstraint","?inlineShapeOrRef"], 
     "ATPNAME_NS": ["inlineShapeOrRef","?nodeConstraint"], 
     "ATPNAME_LN": ["inlineShapeOrRef","?nodeConstraint"], 
     "@": ["inlineShapeOrRef","?nodeConstraint"], 
     "{": ["inlineShapeOrRef","?nodeConstraint"], 
     "CLOSED": ["inlineShapeOrRef","?nodeConstraint"], 
     "EXTENDS": ["inlineShapeOrRef","?nodeConstraint"], 
     "&": ["inlineShapeOrRef","?nodeConstraint"], 
     "RESTRICTS": ["inlineShapeOrRef","?nodeConstraint"], 
     "-": ["inlineShapeOrRef","?nodeConstraint"], 
     "EXTRA": ["inlineShapeOrRef","?nodeConstraint"], 
     "(": ["(","shapeExpression",")"], 
     ".": ["."]}, 
  "inlineShapeDefinition" : {
     "{": ["*qualifier","{","?tripleExpression","}"], 
     "CLOSED": ["*qualifier","{","?tripleExpression","}"], 
     "EXTENDS": ["*qualifier","{","?tripleExpression","}"], 
     "&": ["*qualifier","{","?tripleExpression","}"], 
     "RESTRICTS": ["*qualifier","{","?tripleExpression","}"], 
     "-": ["*qualifier","{","?tripleExpression","}"], 
     "EXTRA": ["*qualifier","{","?tripleExpression","}"]}, 
  "inlineShapeExpression" : {
     "NOT": ["inlineShapeOr"], 
     "(": ["inlineShapeOr"], 
     ".": ["inlineShapeOr"], 
     "LITERAL": ["inlineShapeOr"], 
     "ATPNAME_NS": ["inlineShapeOr"], 
     "ATPNAME_LN": ["inlineShapeOr"], 
     "@": ["inlineShapeOr"], 
     "IRI": ["inlineShapeOr"], 
     "BNODE": ["inlineShapeOr"], 
     "NONLITERAL": ["inlineShapeOr"], 
     "[": ["inlineShapeOr"], 
     "{": ["inlineShapeOr"], 
     "IRI_REF": ["inlineShapeOr"], 
     "REGEXP": ["inlineShapeOr"], 
     "CLOSED": ["inlineShapeOr"], 
     "PNAME_LN": ["inlineShapeOr"], 
     "PNAME_NS": ["inlineShapeOr"], 
     "LENGTH": ["inlineShapeOr"], 
     "MINLENGTH": ["inlineShapeOr"], 
     "MAXLENGTH": ["inlineShapeOr"], 
     "MININCLUSIVE": ["inlineShapeOr"], 
     "MINEXCLUSIVE": ["inlineShapeOr"], 
     "MAXINCLUSIVE": ["inlineShapeOr"], 
     "MAXEXCLUSIVE": ["inlineShapeOr"], 
     "TOTALDIGITS": ["inlineShapeOr"], 
     "FRACTIONDIGITS": ["inlineShapeOr"], 
     "EXTENDS": ["inlineShapeOr"], 
     "&": ["inlineShapeOr"], 
     "RESTRICTS": ["inlineShapeOr"], 
     "-": ["inlineShapeOr"], 
     "EXTRA": ["inlineShapeOr"]}, 
  "inlineShapeNot" : {
     "(": ["?NOT","inlineShapeAtom"], 
     ".": ["?NOT","inlineShapeAtom"], 
     "LITERAL": ["?NOT","inlineShapeAtom"], 
     "ATPNAME_NS": ["?NOT","inlineShapeAtom"], 
     "ATPNAME_LN": ["?NOT","inlineShapeAtom"], 
     "@": ["?NOT","inlineShapeAtom"], 
     "IRI": ["?NOT","inlineShapeAtom"], 
     "BNODE": ["?NOT","inlineShapeAtom"], 
     "NONLITERAL": ["?NOT","inlineShapeAtom"], 
     "[": ["?NOT","inlineShapeAtom"], 
     "{": ["?NOT","inlineShapeAtom"], 
     "IRI_REF": ["?NOT","inlineShapeAtom"], 
     "REGEXP": ["?NOT","inlineShapeAtom"], 
     "CLOSED": ["?NOT","inlineShapeAtom"], 
     "PNAME_LN": ["?NOT","inlineShapeAtom"], 
     "PNAME_NS": ["?NOT","inlineShapeAtom"], 
     "LENGTH": ["?NOT","inlineShapeAtom"], 
     "MINLENGTH": ["?NOT","inlineShapeAtom"], 
     "MAXLENGTH": ["?NOT","inlineShapeAtom"], 
     "MININCLUSIVE": ["?NOT","inlineShapeAtom"], 
     "MINEXCLUSIVE": ["?NOT","inlineShapeAtom"], 
     "MAXINCLUSIVE": ["?NOT","inlineShapeAtom"], 
     "MAXEXCLUSIVE": ["?NOT","inlineShapeAtom"], 
     "TOTALDIGITS": ["?NOT","inlineShapeAtom"], 
     "FRACTIONDIGITS": ["?NOT","inlineShapeAtom"], 
     "EXTENDS": ["?NOT","inlineShapeAtom"], 
     "&": ["?NOT","inlineShapeAtom"], 
     "RESTRICTS": ["?NOT","inlineShapeAtom"], 
     "-": ["?NOT","inlineShapeAtom"], 
     "EXTRA": ["?NOT","inlineShapeAtom"], 
     "NOT": ["?NOT","inlineShapeAtom"]}, 
  "inlineShapeOr" : {
     "NOT": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "(": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     ".": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "LITERAL": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "ATPNAME_NS": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "ATPNAME_LN": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "@": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "IRI": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "BNODE": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "NONLITERAL": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "[": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "{": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "IRI_REF": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "REGEXP": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "CLOSED": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "PNAME_LN": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "PNAME_NS": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "LENGTH": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "MINLENGTH": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "MAXLENGTH": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "MININCLUSIVE": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "MINEXCLUSIVE": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "MAXINCLUSIVE": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "MAXEXCLUSIVE": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "TOTALDIGITS": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "FRACTIONDIGITS": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "EXTENDS": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "&": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "RESTRICTS": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "-": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "EXTRA": ["inlineShapeAnd","*[OR,inlineShapeAnd]"]}, 
  "inlineShapeOrRef" : {
     "{": ["inlineShapeDefinition"], 
     "CLOSED": ["inlineShapeDefinition"], 
     "EXTENDS": ["inlineShapeDefinition"], 
     "&": ["inlineShapeDefinition"], 
     "RESTRICTS": ["inlineShapeDefinition"], 
     "-": ["inlineShapeDefinition"], 
     "EXTRA": ["inlineShapeDefinition"], 
     "ATPNAME_NS": ["ATPNAME_NS"], 
     "ATPNAME_LN": ["ATPNAME_LN"], 
     "@": ["@","shapeExprLabel"]}, 
  "iri" : {
     "IRI_REF": ["or([IRI_REF,prefixedName])"], 
     "PNAME_LN": ["or([IRI_REF,prefixedName])"], 
     "PNAME_NS": ["or([IRI_REF,prefixedName])"]}, 
  "iriRange" : {
     "IRI_REF": ["iri","?[~,*exclusion]"], 
     "PNAME_LN": ["iri","?[~,*exclusion]"], 
     "PNAME_NS": ["iri","?[~,*exclusion]"], 
     ".": [".","+exclusion"]}, 
  "literal" : {
     "INTEGER": ["or([rdfLiteral,numericLiteral,booleanLiteral])"], 
     "DECIMAL": ["or([rdfLiteral,numericLiteral,booleanLiteral])"], 
     "DOUBLE": ["or([rdfLiteral,numericLiteral,booleanLiteral])"], 
     "TRUE": ["or([rdfLiteral,numericLiteral,booleanLiteral])"], 
     "FALSE": ["or([rdfLiteral,numericLiteral,booleanLiteral])"], 
     "STRING_LITERAL1": ["or([rdfLiteral,numericLiteral,booleanLiteral])"], 
     "STRING_LITERAL_LONG1": ["or([rdfLiteral,numericLiteral,booleanLiteral])"], 
     "STRING_LITERAL2": ["or([rdfLiteral,numericLiteral,booleanLiteral])"], 
     "STRING_LITERAL_LONG2": ["or([rdfLiteral,numericLiteral,booleanLiteral])"]}, 
  "nodeConstraint" : {
     "LITERAL": ["LITERAL","*xsFacet"], 
     "IRI": ["nonLiteralKind","*stringFacet"], 
     "BNODE": ["nonLiteralKind","*stringFacet"], 
     "NONLITERAL": ["nonLiteralKind","*stringFacet"], 
     "IRI_REF": ["datatype","*xsFacet"], 
     "PNAME_LN": ["datatype","*xsFacet"], 
     "PNAME_NS": ["datatype","*xsFacet"], 
     "[": ["valueSet","*xsFacet"], 
     "REGEXP": ["+xsFacet"], 
     "LENGTH": ["+xsFacet"], 
     "MINLENGTH": ["+xsFacet"], 
     "MAXLENGTH": ["+xsFacet"], 
     "MININCLUSIVE": ["+xsFacet"], 
     "MINEXCLUSIVE": ["+xsFacet"], 
     "MAXINCLUSIVE": ["+xsFacet"], 
     "MAXEXCLUSIVE": ["+xsFacet"], 
     "TOTALDIGITS": ["+xsFacet"], 
     "FRACTIONDIGITS": ["+xsFacet"]}, 
  "nonLiteralKind" : {
     "IRI": ["IRI"], 
     "BNODE": ["BNODE"], 
     "NONLITERAL": ["NONLITERAL"]}, 
  "notStartAction" : {
     "START": ["or([startt,shapeExprDecl])"], 
     "KW_ABSTRACT": ["or([startt,shapeExprDecl])"], 
     "IRI_REF": ["or([startt,shapeExprDecl])"], 
     "BLANK_NODE_LABEL": ["or([startt,shapeExprDecl])"], 
     "PNAME_LN": ["or([startt,shapeExprDecl])"], 
     "PNAME_NS": ["or([startt,shapeExprDecl])"]}, 
  "numericFacet" : {
     "MININCLUSIVE": ["numericRange","numericLiteral"], 
     "MINEXCLUSIVE": ["numericRange","numericLiteral"], 
     "MAXINCLUSIVE": ["numericRange","numericLiteral"], 
     "MAXEXCLUSIVE": ["numericRange","numericLiteral"], 
     "TOTALDIGITS": ["numericLength","INTEGER"], 
     "FRACTIONDIGITS": ["numericLength","INTEGER"]}, 
  "numericLength" : {
     "TOTALDIGITS": ["TOTALDIGITS"], 
     "FRACTIONDIGITS": ["FRACTIONDIGITS"]}, 
  "numericLiteral" : {
     "INTEGER": ["INTEGER"], 
     "DECIMAL": ["DECIMAL"], 
     "DOUBLE": ["DOUBLE"]}, 
  "numericRange" : {
     "MININCLUSIVE": ["MININCLUSIVE"], 
     "MINEXCLUSIVE": ["MINEXCLUSIVE"], 
     "MAXINCLUSIVE": ["MAXINCLUSIVE"], 
     "MAXEXCLUSIVE": ["MAXEXCLUSIVE"]}, 
  "oneOfTripleExpr" : {
     "$": ["unaryTripleExpr","funaryTripleExpr"], 
     "(": ["unaryTripleExpr","funaryTripleExpr"], 
     "&": ["unaryTripleExpr","funaryTripleExpr"], 
     "A_TOKEN": ["unaryTripleExpr","funaryTripleExpr"], 
     "^": ["unaryTripleExpr","funaryTripleExpr"], 
     "IRI_REF": ["unaryTripleExpr","funaryTripleExpr"], 
     "PNAME_LN": ["unaryTripleExpr","funaryTripleExpr"], 
     "PNAME_NS": ["unaryTripleExpr","funaryTripleExpr"]}, 
  "or([CODE,%])" : {
     "CODE": ["CODE"], 
     "%": ["%"]}, 
  "or([IRI_REF,prefixedName])" : {
     "IRI_REF": ["IRI_REF"], 
     "PNAME_LN": ["prefixedName"], 
     "PNAME_NS": ["prefixedName"]}, 
  "or([PNAME_LN,PNAME_NS])" : {
     "PNAME_LN": ["PNAME_LN"], 
     "PNAME_NS": ["PNAME_NS"]}, 
  "or([TRUE,FALSE])" : {
     "TRUE": ["TRUE"], 
     "FALSE": ["FALSE"]}, 
  "or([baseDecl,prefixDecl,importDecl])" : {
     "BASE": ["baseDecl"], 
     "PREFIX": ["prefixDecl"], 
     "IMPORT": ["importDecl"]}, 
  "or([directive,notStartAction])" : {
     "BASE": ["directive"], 
     "PREFIX": ["directive"], 
     "IMPORT": ["directive"], 
     "START": ["notStartAction"], 
     "KW_ABSTRACT": ["notStartAction"], 
     "IRI_REF": ["notStartAction"], 
     "BLANK_NODE_LABEL": ["notStartAction"], 
     "PNAME_LN": ["notStartAction"], 
     "PNAME_NS": ["notStartAction"]}, 
  "or([extension,restriction,extraPropertySet,CLOSED])" : {
     "EXTENDS": ["extension"], 
     "&": ["extension"], 
     "RESTRICTS": ["restriction"], 
     "-": ["restriction"], 
     "EXTRA": ["extraPropertySet"], 
     "CLOSED": ["CLOSED"]}, 
  "or([iri,A_TOKEN])" : {
     "IRI_REF": ["iri"], 
     "PNAME_LN": ["iri"], 
     "PNAME_NS": ["iri"], 
     "A_TOKEN": ["A_TOKEN"]}, 
  "or([iri,blankNode])" : {
     "IRI_REF": ["iri"], 
     "PNAME_LN": ["iri"], 
     "PNAME_NS": ["iri"], 
     "BLANK_NODE_LABEL": ["blankNode"]}, 
  "or([iri,literal])" : {
     "IRI_REF": ["iri"], 
     "PNAME_LN": ["iri"], 
     "PNAME_NS": ["iri"], 
     "INTEGER": ["literal"], 
     "DECIMAL": ["literal"], 
     "DOUBLE": ["literal"], 
     "TRUE": ["literal"], 
     "FALSE": ["literal"], 
     "STRING_LITERAL1": ["literal"], 
     "STRING_LITERAL_LONG1": ["literal"], 
     "STRING_LITERAL2": ["literal"], 
     "STRING_LITERAL_LONG2": ["literal"]}, 
  "or([notStartAction,startActions])" : {
     "START": ["notStartAction"], 
     "KW_ABSTRACT": ["notStartAction"], 
     "IRI_REF": ["notStartAction"], 
     "BLANK_NODE_LABEL": ["notStartAction"], 
     "PNAME_LN": ["notStartAction"], 
     "PNAME_NS": ["notStartAction"], 
     "%": ["startActions"]}, 
  "or([rdfLiteral,numericLiteral,booleanLiteral])" : {
     "STRING_LITERAL1": ["rdfLiteral"], 
     "STRING_LITERAL_LONG1": ["rdfLiteral"], 
     "STRING_LITERAL2": ["rdfLiteral"], 
     "STRING_LITERAL_LONG2": ["rdfLiteral"], 
     "INTEGER": ["numericLiteral"], 
     "DECIMAL": ["numericLiteral"], 
     "DOUBLE": ["numericLiteral"], 
     "TRUE": ["booleanLiteral"], 
     "FALSE": ["booleanLiteral"]}, 
  "or([shapeDefinition,shapeRef])" : {
     "{": ["shapeDefinition"], 
     "CLOSED": ["shapeDefinition"], 
     "EXTENDS": ["shapeDefinition"], 
     "&": ["shapeDefinition"], 
     "RESTRICTS": ["shapeDefinition"], 
     "-": ["shapeDefinition"], 
     "EXTRA": ["shapeDefinition"], 
     "ATPNAME_NS": ["shapeRef"], 
     "ATPNAME_LN": ["shapeRef"], 
     "@": ["shapeRef"]}, 
  "or([shapeExpression,EXTERNAL])" : {
     "NOT": ["shapeExpression"], 
     "(": ["shapeExpression"], 
     ".": ["shapeExpression"], 
     "LITERAL": ["shapeExpression"], 
     "IRI": ["shapeExpression"], 
     "BNODE": ["shapeExpression"], 
     "NONLITERAL": ["shapeExpression"], 
     "[": ["shapeExpression"], 
     "ATPNAME_NS": ["shapeExpression"], 
     "ATPNAME_LN": ["shapeExpression"], 
     "@": ["shapeExpression"], 
     "IRI_REF": ["shapeExpression"], 
     "REGEXP": ["shapeExpression"], 
     "{": ["shapeExpression"], 
     "PNAME_LN": ["shapeExpression"], 
     "PNAME_NS": ["shapeExpression"], 
     "LENGTH": ["shapeExpression"], 
     "MINLENGTH": ["shapeExpression"], 
     "MAXLENGTH": ["shapeExpression"], 
     "MININCLUSIVE": ["shapeExpression"], 
     "MINEXCLUSIVE": ["shapeExpression"], 
     "MAXINCLUSIVE": ["shapeExpression"], 
     "MAXEXCLUSIVE": ["shapeExpression"], 
     "TOTALDIGITS": ["shapeExpression"], 
     "FRACTIONDIGITS": ["shapeExpression"], 
     "CLOSED": ["shapeExpression"], 
     "EXTENDS": ["shapeExpression"], 
     "&": ["shapeExpression"], 
     "RESTRICTS": ["shapeExpression"], 
     "-": ["shapeExpression"], 
     "EXTRA": ["shapeExpression"], 
     "EXTERNAL": ["EXTERNAL"]}, 
  "or([startt,shapeExprDecl])" : {
     "START": ["startt"], 
     "KW_ABSTRACT": ["shapeExprDecl"], 
     "IRI_REF": ["shapeExprDecl"], 
     "BLANK_NODE_LABEL": ["shapeExprDecl"], 
     "PNAME_LN": ["shapeExprDecl"], 
     "PNAME_NS": ["shapeExprDecl"]}, 
  "or([stringFacet,numericFacet])" : {
     "REGEXP": ["stringFacet"], 
     "LENGTH": ["stringFacet"], 
     "MINLENGTH": ["stringFacet"], 
     "MAXLENGTH": ["stringFacet"], 
     "MININCLUSIVE": ["numericFacet"], 
     "MINEXCLUSIVE": ["numericFacet"], 
     "MAXINCLUSIVE": ["numericFacet"], 
     "MAXEXCLUSIVE": ["numericFacet"], 
     "TOTALDIGITS": ["numericFacet"], 
     "FRACTIONDIGITS": ["numericFacet"]}, 
  "or([tripleConstraint,bracketedTripleExpr])" : {
     "A_TOKEN": ["tripleConstraint"], 
     "^": ["tripleConstraint"], 
     "IRI_REF": ["tripleConstraint"], 
     "PNAME_LN": ["tripleConstraint"], 
     "PNAME_NS": ["tripleConstraint"], 
     "(": ["bracketedTripleExpr"]}, 
  "predicate" : {
     "A_TOKEN": ["or([iri,A_TOKEN])"], 
     "IRI_REF": ["or([iri,A_TOKEN])"], 
     "PNAME_LN": ["or([iri,A_TOKEN])"], 
     "PNAME_NS": ["or([iri,A_TOKEN])"]}, 
  "prefixDecl" : {
     "PREFIX": ["PREFIX","PNAME_NS","IRI_REF"]}, 
  "prefixedName" : {
     "PNAME_LN": ["or([PNAME_LN,PNAME_NS])"], 
     "PNAME_NS": ["or([PNAME_LN,PNAME_NS])"]}, 
  "qualifier" : {
     "CLOSED": ["or([extension,restriction,extraPropertySet,CLOSED])"], 
     "EXTENDS": ["or([extension,restriction,extraPropertySet,CLOSED])"], 
     "&": ["or([extension,restriction,extraPropertySet,CLOSED])"], 
     "RESTRICTS": ["or([extension,restriction,extraPropertySet,CLOSED])"], 
     "-": ["or([extension,restriction,extraPropertySet,CLOSED])"], 
     "EXTRA": ["or([extension,restriction,extraPropertySet,CLOSED])"]}, 
  "rdfLit" : {
     "LANGTAG": ["LANGTAG"], 
     "^": ["^","^","datatype"], 
     ".": [], 
     "IRI_REF": [], 
     "INTEGER": [], 
     "DECIMAL": [], 
     "DOUBLE": [], 
     "TRUE": [], 
     "FALSE": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "STRING_LITERAL1": [], 
     "STRING_LITERAL_LONG1": [], 
     "STRING_LITERAL2": [], 
     "STRING_LITERAL_LONG2": [], 
     "]": [], 
     "DOUBLE_SLASH": [], 
     "%": [], 
     "OR": [], 
     "AND_TOKEN": [], 
     "|": [], 
     ";": [], 
     ")": [], 
     "}": [], 
     "BASE": [], 
     "PREFIX": [], 
     "IMPORT": [], 
     "START": [], 
     "KW_ABSTRACT": [], 
     "BLANK_NODE_LABEL": [], 
     "$": []}, 
  "rdfLiteral" : {
     "STRING_LITERAL1": ["string","rdfLit"], 
     "STRING_LITERAL_LONG1": ["string","rdfLit"], 
     "STRING_LITERAL2": ["string","rdfLit"], 
     "STRING_LITERAL_LONG2": ["string","rdfLit"]}, 
  "restriction" : {
     "RESTRICTS": ["RESTRICTS","shapeRef"], 
     "-": ["-","shapeRef"]}, 
  "semanticActions" : {
     "%": ["*codeDecl"], 
     "OR": ["*codeDecl"], 
     "AND_TOKEN": ["*codeDecl"], 
     "|": ["*codeDecl"], 
     ";": ["*codeDecl"], 
     ")": ["*codeDecl"], 
     "}": ["*codeDecl"], 
     "BASE": ["*codeDecl"], 
     "PREFIX": ["*codeDecl"], 
     "IMPORT": ["*codeDecl"], 
     "START": ["*codeDecl"], 
     "KW_ABSTRACT": ["*codeDecl"], 
     "IRI_REF": ["*codeDecl"], 
     "BLANK_NODE_LABEL": ["*codeDecl"], 
     "PNAME_LN": ["*codeDecl"], 
     "PNAME_NS": ["*codeDecl"], 
     "$": ["*codeDecl"]}, 
  "senseFlags" : {
     "^": ["^"]}, 
  "shapeAnd" : {
     "NOT": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "(": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     ".": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "LITERAL": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "IRI": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "BNODE": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "NONLITERAL": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "[": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "ATPNAME_NS": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "ATPNAME_LN": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "@": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "IRI_REF": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "REGEXP": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "{": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "PNAME_LN": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "PNAME_NS": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "LENGTH": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "MINLENGTH": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "MAXLENGTH": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "MININCLUSIVE": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "MINEXCLUSIVE": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "MAXINCLUSIVE": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "MAXEXCLUSIVE": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "TOTALDIGITS": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "FRACTIONDIGITS": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "CLOSED": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "EXTENDS": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "&": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "RESTRICTS": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "-": ["shapeNot","*[AND_TOKEN,shapeNot]"], 
     "EXTRA": ["shapeNot","*[AND_TOKEN,shapeNot]"]}, 
  "shapeAtom" : {
     "LITERAL": ["nodeConstraint","?shapeOrRef"], 
     "IRI": ["nodeConstraint","?shapeOrRef"], 
     "BNODE": ["nodeConstraint","?shapeOrRef"], 
     "NONLITERAL": ["nodeConstraint","?shapeOrRef"], 
     "[": ["nodeConstraint","?shapeOrRef"], 
     "IRI_REF": ["nodeConstraint","?shapeOrRef"], 
     "REGEXP": ["nodeConstraint","?shapeOrRef"], 
     "PNAME_LN": ["nodeConstraint","?shapeOrRef"], 
     "PNAME_NS": ["nodeConstraint","?shapeOrRef"], 
     "LENGTH": ["nodeConstraint","?shapeOrRef"], 
     "MINLENGTH": ["nodeConstraint","?shapeOrRef"], 
     "MAXLENGTH": ["nodeConstraint","?shapeOrRef"], 
     "MININCLUSIVE": ["nodeConstraint","?shapeOrRef"], 
     "MINEXCLUSIVE": ["nodeConstraint","?shapeOrRef"], 
     "MAXINCLUSIVE": ["nodeConstraint","?shapeOrRef"], 
     "MAXEXCLUSIVE": ["nodeConstraint","?shapeOrRef"], 
     "TOTALDIGITS": ["nodeConstraint","?shapeOrRef"], 
     "FRACTIONDIGITS": ["nodeConstraint","?shapeOrRef"], 
     "ATPNAME_NS": ["shapeOrRef"], 
     "ATPNAME_LN": ["shapeOrRef"], 
     "@": ["shapeOrRef"], 
     "{": ["shapeOrRef"], 
     "CLOSED": ["shapeOrRef"], 
     "EXTENDS": ["shapeOrRef"], 
     "&": ["shapeOrRef"], 
     "RESTRICTS": ["shapeOrRef"], 
     "-": ["shapeOrRef"], 
     "EXTRA": ["shapeOrRef"], 
     "(": ["(","shapeExpression",")"], 
     ".": ["."]}, 
  "shapeDefinition" : {
     "{": ["inlineShapeDefinition","*annotation","semanticActions"], 
     "CLOSED": ["inlineShapeDefinition","*annotation","semanticActions"], 
     "EXTENDS": ["inlineShapeDefinition","*annotation","semanticActions"], 
     "&": ["inlineShapeDefinition","*annotation","semanticActions"], 
     "RESTRICTS": ["inlineShapeDefinition","*annotation","semanticActions"], 
     "-": ["inlineShapeDefinition","*annotation","semanticActions"], 
     "EXTRA": ["inlineShapeDefinition","*annotation","semanticActions"]}, 
  "shapeExprDecl" : {
     "IRI_REF": ["?KW_ABSTRACT","shapeExprLabel","or([shapeExpression,EXTERNAL])"], 
     "BLANK_NODE_LABEL": ["?KW_ABSTRACT","shapeExprLabel","or([shapeExpression,EXTERNAL])"], 
     "PNAME_LN": ["?KW_ABSTRACT","shapeExprLabel","or([shapeExpression,EXTERNAL])"], 
     "PNAME_NS": ["?KW_ABSTRACT","shapeExprLabel","or([shapeExpression,EXTERNAL])"], 
     "KW_ABSTRACT": ["?KW_ABSTRACT","shapeExprLabel","or([shapeExpression,EXTERNAL])"]}, 
  "shapeExprLabel" : {
     "IRI_REF": ["or([iri,blankNode])"], 
     "BLANK_NODE_LABEL": ["or([iri,blankNode])"], 
     "PNAME_LN": ["or([iri,blankNode])"], 
     "PNAME_NS": ["or([iri,blankNode])"]}, 
  "shapeExpression" : {
     "NOT": ["shapeOr"], 
     "(": ["shapeOr"], 
     ".": ["shapeOr"], 
     "LITERAL": ["shapeOr"], 
     "IRI": ["shapeOr"], 
     "BNODE": ["shapeOr"], 
     "NONLITERAL": ["shapeOr"], 
     "[": ["shapeOr"], 
     "ATPNAME_NS": ["shapeOr"], 
     "ATPNAME_LN": ["shapeOr"], 
     "@": ["shapeOr"], 
     "IRI_REF": ["shapeOr"], 
     "REGEXP": ["shapeOr"], 
     "{": ["shapeOr"], 
     "PNAME_LN": ["shapeOr"], 
     "PNAME_NS": ["shapeOr"], 
     "LENGTH": ["shapeOr"], 
     "MINLENGTH": ["shapeOr"], 
     "MAXLENGTH": ["shapeOr"], 
     "MININCLUSIVE": ["shapeOr"], 
     "MINEXCLUSIVE": ["shapeOr"], 
     "MAXINCLUSIVE": ["shapeOr"], 
     "MAXEXCLUSIVE": ["shapeOr"], 
     "TOTALDIGITS": ["shapeOr"], 
     "FRACTIONDIGITS": ["shapeOr"], 
     "CLOSED": ["shapeOr"], 
     "EXTENDS": ["shapeOr"], 
     "&": ["shapeOr"], 
     "RESTRICTS": ["shapeOr"], 
     "-": ["shapeOr"], 
     "EXTRA": ["shapeOr"]}, 
  "shapeNot" : {
     "(": ["?NOT","shapeAtom"], 
     ".": ["?NOT","shapeAtom"], 
     "LITERAL": ["?NOT","shapeAtom"], 
     "IRI": ["?NOT","shapeAtom"], 
     "BNODE": ["?NOT","shapeAtom"], 
     "NONLITERAL": ["?NOT","shapeAtom"], 
     "[": ["?NOT","shapeAtom"], 
     "ATPNAME_NS": ["?NOT","shapeAtom"], 
     "ATPNAME_LN": ["?NOT","shapeAtom"], 
     "@": ["?NOT","shapeAtom"], 
     "IRI_REF": ["?NOT","shapeAtom"], 
     "REGEXP": ["?NOT","shapeAtom"], 
     "{": ["?NOT","shapeAtom"], 
     "PNAME_LN": ["?NOT","shapeAtom"], 
     "PNAME_NS": ["?NOT","shapeAtom"], 
     "LENGTH": ["?NOT","shapeAtom"], 
     "MINLENGTH": ["?NOT","shapeAtom"], 
     "MAXLENGTH": ["?NOT","shapeAtom"], 
     "MININCLUSIVE": ["?NOT","shapeAtom"], 
     "MINEXCLUSIVE": ["?NOT","shapeAtom"], 
     "MAXINCLUSIVE": ["?NOT","shapeAtom"], 
     "MAXEXCLUSIVE": ["?NOT","shapeAtom"], 
     "TOTALDIGITS": ["?NOT","shapeAtom"], 
     "FRACTIONDIGITS": ["?NOT","shapeAtom"], 
     "CLOSED": ["?NOT","shapeAtom"], 
     "EXTENDS": ["?NOT","shapeAtom"], 
     "&": ["?NOT","shapeAtom"], 
     "RESTRICTS": ["?NOT","shapeAtom"], 
     "-": ["?NOT","shapeAtom"], 
     "EXTRA": ["?NOT","shapeAtom"], 
     "NOT": ["?NOT","shapeAtom"]}, 
  "shapeOr" : {
     "NOT": ["shapeAnd","*[OR,shapeAnd]"], 
     "(": ["shapeAnd","*[OR,shapeAnd]"], 
     ".": ["shapeAnd","*[OR,shapeAnd]"], 
     "LITERAL": ["shapeAnd","*[OR,shapeAnd]"], 
     "IRI": ["shapeAnd","*[OR,shapeAnd]"], 
     "BNODE": ["shapeAnd","*[OR,shapeAnd]"], 
     "NONLITERAL": ["shapeAnd","*[OR,shapeAnd]"], 
     "[": ["shapeAnd","*[OR,shapeAnd]"], 
     "ATPNAME_NS": ["shapeAnd","*[OR,shapeAnd]"], 
     "ATPNAME_LN": ["shapeAnd","*[OR,shapeAnd]"], 
     "@": ["shapeAnd","*[OR,shapeAnd]"], 
     "IRI_REF": ["shapeAnd","*[OR,shapeAnd]"], 
     "REGEXP": ["shapeAnd","*[OR,shapeAnd]"], 
     "{": ["shapeAnd","*[OR,shapeAnd]"], 
     "PNAME_LN": ["shapeAnd","*[OR,shapeAnd]"], 
     "PNAME_NS": ["shapeAnd","*[OR,shapeAnd]"], 
     "LENGTH": ["shapeAnd","*[OR,shapeAnd]"], 
     "MINLENGTH": ["shapeAnd","*[OR,shapeAnd]"], 
     "MAXLENGTH": ["shapeAnd","*[OR,shapeAnd]"], 
     "MININCLUSIVE": ["shapeAnd","*[OR,shapeAnd]"], 
     "MINEXCLUSIVE": ["shapeAnd","*[OR,shapeAnd]"], 
     "MAXINCLUSIVE": ["shapeAnd","*[OR,shapeAnd]"], 
     "MAXEXCLUSIVE": ["shapeAnd","*[OR,shapeAnd]"], 
     "TOTALDIGITS": ["shapeAnd","*[OR,shapeAnd]"], 
     "FRACTIONDIGITS": ["shapeAnd","*[OR,shapeAnd]"], 
     "CLOSED": ["shapeAnd","*[OR,shapeAnd]"], 
     "EXTENDS": ["shapeAnd","*[OR,shapeAnd]"], 
     "&": ["shapeAnd","*[OR,shapeAnd]"], 
     "RESTRICTS": ["shapeAnd","*[OR,shapeAnd]"], 
     "-": ["shapeAnd","*[OR,shapeAnd]"], 
     "EXTRA": ["shapeAnd","*[OR,shapeAnd]"]}, 
  "shapeOrRef" : {
     "ATPNAME_NS": ["or([shapeDefinition,shapeRef])"], 
     "ATPNAME_LN": ["or([shapeDefinition,shapeRef])"], 
     "@": ["or([shapeDefinition,shapeRef])"], 
     "{": ["or([shapeDefinition,shapeRef])"], 
     "CLOSED": ["or([shapeDefinition,shapeRef])"], 
     "EXTENDS": ["or([shapeDefinition,shapeRef])"], 
     "&": ["or([shapeDefinition,shapeRef])"], 
     "RESTRICTS": ["or([shapeDefinition,shapeRef])"], 
     "-": ["or([shapeDefinition,shapeRef])"], 
     "EXTRA": ["or([shapeDefinition,shapeRef])"]}, 
  "shapeRef" : {
     "ATPNAME_NS": ["ATPNAME_NS"], 
     "ATPNAME_LN": ["ATPNAME_LN"], 
     "@": ["@","shapeExprLabel"]}, 
  "shexDoC" : {
     "$": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "START": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "KW_ABSTRACT": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "%": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "IRI_REF": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "BLANK_NODE_LABEL": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "PNAME_LN": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "PNAME_NS": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "BASE": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "PREFIX": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "IMPORT": ["*directive","?[or([notStartAction,startActions]),*statement]","$"]}, 
  "singleElementGroup" : {
     ";": [";","elementGroup"], 
     "|": [], 
     ")": [], 
     "}": []}, 
  "startActions" : {
     "%": ["+codeDecl"]}, 
  "startt" : {
     "START": ["START","=","shapeExpression"]}, 
  "statement" : {
     "BASE": ["or([directive,notStartAction])"], 
     "PREFIX": ["or([directive,notStartAction])"], 
     "IMPORT": ["or([directive,notStartAction])"], 
     "START": ["or([directive,notStartAction])"], 
     "KW_ABSTRACT": ["or([directive,notStartAction])"], 
     "IRI_REF": ["or([directive,notStartAction])"], 
     "BLANK_NODE_LABEL": ["or([directive,notStartAction])"], 
     "PNAME_LN": ["or([directive,notStartAction])"], 
     "PNAME_NS": ["or([directive,notStartAction])"]}, 
  "string" : {
     "STRING_LITERAL1": ["STRING_LITERAL1"], 
     "STRING_LITERAL_LONG1": ["STRING_LITERAL_LONG1"], 
     "STRING_LITERAL2": ["STRING_LITERAL2"], 
     "STRING_LITERAL_LONG2": ["STRING_LITERAL_LONG2"]}, 
  "stringFacet" : {
     "LENGTH": ["stringLength","INTEGER"], 
     "MINLENGTH": ["stringLength","INTEGER"], 
     "MAXLENGTH": ["stringLength","INTEGER"], 
     "REGEXP": ["REGEXP"]}, 
  "stringLength" : {
     "LENGTH": ["LENGTH"], 
     "MINLENGTH": ["MINLENGTH"], 
     "MAXLENGTH": ["MAXLENGTH"]}, 
  "tripleConstraint" : {
     "A_TOKEN": ["?senseFlags","predicate","inlineShapeExpression","?cardinality","*annotation","semanticActions"], 
     "IRI_REF": ["?senseFlags","predicate","inlineShapeExpression","?cardinality","*annotation","semanticActions"], 
     "PNAME_LN": ["?senseFlags","predicate","inlineShapeExpression","?cardinality","*annotation","semanticActions"], 
     "PNAME_NS": ["?senseFlags","predicate","inlineShapeExpression","?cardinality","*annotation","semanticActions"], 
     "^": ["?senseFlags","predicate","inlineShapeExpression","?cardinality","*annotation","semanticActions"]}, 
  "tripleExprLabel" : {
     "IRI_REF": ["or([iri,blankNode])"], 
     "BLANK_NODE_LABEL": ["or([iri,blankNode])"], 
     "PNAME_LN": ["or([iri,blankNode])"], 
     "PNAME_NS": ["or([iri,blankNode])"]}, 
  "tripleExpression" : {
     "$": ["oneOfTripleExpr"], 
     "(": ["oneOfTripleExpr"], 
     "&": ["oneOfTripleExpr"], 
     "A_TOKEN": ["oneOfTripleExpr"], 
     "^": ["oneOfTripleExpr"], 
     "IRI_REF": ["oneOfTripleExpr"], 
     "PNAME_LN": ["oneOfTripleExpr"], 
     "PNAME_NS": ["oneOfTripleExpr"]}, 
  "unaryTripleExpr" : {
     "(": ["?[$,tripleExprLabel]","or([tripleConstraint,bracketedTripleExpr])"], 
     "A_TOKEN": ["?[$,tripleExprLabel]","or([tripleConstraint,bracketedTripleExpr])"], 
     "^": ["?[$,tripleExprLabel]","or([tripleConstraint,bracketedTripleExpr])"], 
     "IRI_REF": ["?[$,tripleExprLabel]","or([tripleConstraint,bracketedTripleExpr])"], 
     "PNAME_LN": ["?[$,tripleExprLabel]","or([tripleConstraint,bracketedTripleExpr])"], 
     "PNAME_NS": ["?[$,tripleExprLabel]","or([tripleConstraint,bracketedTripleExpr])"], 
     "$": ["?[$,tripleExprLabel]","or([tripleConstraint,bracketedTripleExpr])"], 
     "&": ["include"]}, 
  "valueSet" : {
     "[": ["[","*valueSetValue","]"]}, 
  "valueSetValue" : {
     ".": ["iriRange"], 
     "IRI_REF": ["iriRange"], 
     "PNAME_LN": ["iriRange"], 
     "PNAME_NS": ["iriRange"], 
     "INTEGER": ["literal"], 
     "DECIMAL": ["literal"], 
     "DOUBLE": ["literal"], 
     "TRUE": ["literal"], 
     "FALSE": ["literal"], 
     "STRING_LITERAL1": ["literal"], 
     "STRING_LITERAL_LONG1": ["literal"], 
     "STRING_LITERAL2": ["literal"], 
     "STRING_LITERAL_LONG2": ["literal"]}, 
  "xsFacet" : {
     "REGEXP": ["or([stringFacet,numericFacet])"], 
     "LENGTH": ["or([stringFacet,numericFacet])"], 
     "MINLENGTH": ["or([stringFacet,numericFacet])"], 
     "MAXLENGTH": ["or([stringFacet,numericFacet])"], 
     "MININCLUSIVE": ["or([stringFacet,numericFacet])"], 
     "MINEXCLUSIVE": ["or([stringFacet,numericFacet])"], 
     "MAXINCLUSIVE": ["or([stringFacet,numericFacet])"], 
     "MAXEXCLUSIVE": ["or([stringFacet,numericFacet])"], 
     "TOTALDIGITS": ["or([stringFacet,numericFacet])"], 
     "FRACTIONDIGITS": ["or([stringFacet,numericFacet])"]}
},

keywords:/^(RESTRICTS|EXTENDS|BASE|PREFIX|IMPORT|EXTERNAL|OR|NOT|LITERAL|NONLITERAL|IRI|BNODE|LENGTH|MINLENGTH|MAXLENGTH|MININCLUSIVE|MINEXCLUSIVE|MAXINCLUSIVE|MAXEXCLUSIVE|TOTALDIGITS|FRACTIONDIGITS|CLOSED|EXTRA|TRUE|FALSE|START)/i ,

punct:/^(=|\(|\)|\.|@|\{|\}|\||;|\*|\+|\?|\^|\[|\]|\-|\~|\&|%|\$)/ ,

startSymbol:"shexDoC",
acceptEmpty:true,
}